var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStoreClass = function SvgStoreClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 11.2a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Zm17.6.8a.8.8 0 1 1 0 1.6H6.4a.8.8 0 1 1 0-1.6ZM1.6 5.6a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Zm17.6.8a.8.8 0 1 1 0 1.6H6.4a.8.8 0 0 1 0-1.6ZM1.6 0a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2Zm17.6.8a.8.8 0 1 1 0 1.6H6.4a.8.8 0 0 1 0-1.6Z",
    fill: "#333"
  })));
};

export default SvgStoreClass;